'use client'
import React, { createContext, useState, useContext } from 'react';

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
    const [activeConversation, setActiveConversation] = useState(null);

    return (
        <ChatContext.Provider value={{ activeConversation, setActiveConversation }}>
            {children}
        </ChatContext.Provider>
    );
};

export const useChatContext = () => useContext(ChatContext);
